import { get, upload, post } from '@api/request';

export async function fetchMineralImports(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimports`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMineralImportTypes(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimporttype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createMineralImportRun(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimports`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function fetchMineralImport(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function matchMineralImportRun(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/match`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function importMineralImportRun(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/import`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function downloadImportFile(
  { appraisalNoticeService },
  authenticationToken,
  { importID, s3Id },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/file`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

export async function fetchMineralImportValidationErrors(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/validationerrorsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMineralImportValidationErrorDetails(
  { appraisalNoticeService },
  authenticationToken,
  { importID, errorType, page, pageSize },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/validationerrors/${errorType}?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMineralImportMatchedProperties(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/properties/match`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMineralImportMatchedAgents(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/properties/agent/matched`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMineralImportMatchedOwners(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/properties/owner/matched`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMineralImportNewProperties(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/properties/no match`;
  const { body } = await get(authenticationToken, url);
  return body;
} 

export async function fetchMineralImportNewAgents(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/properties/agent/new agent`;
  const { body } = await get(authenticationToken, url);
  return body;
} 

export async function fetchMineralImportNewOwners(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/properties/owner/new owner`;
  const { body } = await get(authenticationToken, url);
  return body;
} 

export async function fetchMineralImportErrorProperties(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/properties/error`;
  const { body } = await get(authenticationToken, url);
  return body;
} 

export async function fetchMineralImportErrorAgents(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/properties/agent/error`;
  const { body } = await get(authenticationToken, url);
  return body;
} 

export async function fetchMineralImportErrorOwners(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/properties/owner/error`;
  const { body } = await get(authenticationToken, url);
  return body;
} 

export async function fetchMineralImportMineralDetails(
  { appraisalNoticeService },
  authenticationToken,
  { importID, propertyType },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/proptype/${propertyType}`;
  const { body } = await get(authenticationToken, url);
  return body;
} 

export async function fetchMineralImportDeletedDetails(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/mineralimport/${importID}/deleted`;
  const { body } = await get(authenticationToken, url);
  return body;
} 